import React from 'react'

import { Styles } from '../style/tabStyle';

const Tabs = (props) => {
  const { tab, setTab } = props
  
  return (
    <Styles>
      <div className="tabs">
        <div className={`tab${tab === "currencies" ? " active" : ""}`} onClick={() => setTab('currencies')}>
          ارز
        </div>
        <div className={`tab${tab === "golds" ? " active" : ""}`} onClick={() => setTab('golds')}>
          طلا و سکه
        </div>
        <div className="live-badge"><span className="live-dot" />زنده</div>
      </div>
    </Styles>
  );
}
export default Tabs
